
import UMUM from "../../library/umum";

export default {
  data() {
    return {
      form: {
        id: "",
        tahun: "",
        indikator: "",
        uraian: "",
        a: 0,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0,
        g: 0,
        h: 0,
        i: 0,
        keterangan: "",
        createAt: "",
        editedAt: "",
      },

      tahun: "",
      sumber: "",
      kendala: "",
      indikator: "",
      nama_tahun: "",
      nama_kadis: "",
      nip_kadis: "",
      pangkat_kadis: "",
      gol_kadis: "",
      ruang_kadis: "",
      gel_bel_kadis: "",
      gel_dep_kadis: "",

      list_data: [],
      cetak_data: [],
      list_tahun: [],
      list_kecamatan: [],
      list_indikator: [],

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data: true,

      mdl_add: false,
      mdl_cetak: false,
      mdl_print: false,
      mdl_download: false,
      mdl_edit: false,
      mdl_hapus: false,
      btn_add: false,

      UMUM: UMUM,
    };
  },
  computed: {

    subTotalCols() {
      const cols = this.indikatorSchema.table.sumColumns;
      const rows = this.normalizedCetakRows;

      const totals = {};

      cols.forEach((c) => (totals[c] = 0));

      totals.sumOfPercentage = 0;

      rows.forEach((r) => {
        cols.forEach((c) => {
          totals[c] += Number(r[c] || 0);
        });
        totals.sumOfPercentage += Number(r.percentage || 0);
      });

      // 👉 Hitung percentage dari total A dan total B
      let percentage = 0;
      percentage = totals.a > 0 ? ((totals.b / totals.a) * 1000).toFixed(0) : 0;

      totals.percentage = percentage;

      return totals;
    },

    grandTotal() {
      const cols =
        this.indikatorSchema.table.sumColumns ||
        this.indikatorSchema.table.bodyColumns;
      return cols.reduce(
        (sum, c) => sum + Number(this.subTotalCols[c] || 0),
        0,
      );
    },
    indikatorSchema() {
      const id = Number(this.form?.indikator?.id);

      // helper cepat
      const num = (v) => Number(v || 0);

      const isCetak = this.mdl_cetak;

      // =========================
      // INDIKATOR 1
      // =========================
      if (id === 1) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kelompok Umur", width: "12%" },
                { label: "Jumlah Kelompok Umur (ΣPfi)" },
                { label: "Jumlah Kelahiran (ΣBi)" },
                { label: "ASFR", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["a", "b", "percentage"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showSubTotal: true,
            showGrandTotal: false,
            showKet: false,
            showAksi: !isCetak,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Jumlah Kelompok Umur (ΣPfi)",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "Jumlah Kelahiran (ΣBi)",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: false,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              percentage: a > 0 ? ((b / a) * 1000).toFixed(0) : 0,
            };
          },
        };
      }
      // =========================
      // INDIKATOR 2
      // =========================
      if (id === 2) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Uraian Dokumen", width: "12%" },
                { label: "Target TFR Kabupaten/Kota", width: "12%" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["a",],
            sumColumns: ["a"],
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Target TFR Kabupaten/Kota",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);

            return {
              ...row,
              a,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 3
      // =========================
      if (id === 3) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                { label: "Peserta KB Aktif Modern", rowspan: 2, width: "12%" },
                { label: "METODE KONTRASEPSI MODERN", colspan: 9 },
                { label: "KET", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "SUNTIK" },
                { label: "PIL" },
                { label: "KONDOM" },
                { label: "IMPLAN" },
                { label: "IUD/AKDR" },
                { label: "VASEKTOMI/MOP" },
                { label: "TUBEKTOMI/MOW" },
                { label: "MAL" },
                { label: "TOTAL" },
              ],
            ],

            bodyColumns: ["a", "b", "c", "d", "e", "f", "g", "h", "i"],
            sumColumns: ["a", "b", "c", "d", "e", "f", "g", "h", "i"],
            showTotal: true,
            showSubTotal: true,
            showGrandTotal: false,
            showKet: true,
            showAksi: !isCetak,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Peserta KB Aktif Modern",
                    type: "number",
                  },
                ],
              },
              {
                title: "METODE KONTRASEPSI MODERN",
                cols: 4,
                fields: [
                  {
                    key: "b",
                    label: "SUNTIK",
                    type: "number",
                  },
                  {
                    key: "c",
                    label: "PIL",
                    type: "number",
                  },
                  {
                    key: "d",
                    label: "KONDOM",
                    type: "number",
                  },
                  {
                    key: "e",
                    label: "IMPLAN",
                    type: "number",
                  },
                  {
                    key: "f",
                    label: "IUD/AKDR",
                    type: "number",
                  },
                  {
                    key: "g",
                    label: "VASEKTOMI/MOP",
                    type: "number",
                  },
                  {
                    key: "h",
                    label: "TUBEKTOMI/MOW",
                    type: "number",
                  },
                  {
                    key: "i",
                    label: "MAL",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);
            const e = num(row.e);
            const f = num(row.f);
            const g = num(row.g);
            const h = num(row.h);
            const i = num(row.i);

            return {
              ...row,
              a,
              b,
              c,
              d,
              e,
              f,
              g,
              h,
              i,
              total: b + c + d + e + f + g + h + i,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 4
      // =========================
      if (id === 4) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kabupaten / Kota", width: "12%" },
                { label: "Pasangan Usia Subur (PUS)", width: "12%" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["a"],
            sumColumns: ["a"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  { key: "a", label: "Pasangan Usia Subur (PUS)", type: "number" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);

            return {
              ...row,
              a,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 5
      // =========================
      if (id === 5) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                { label: "PUS Bukan Peserta KB", colspan: 5 },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "HAMIL" },
                { label: "IAS" },
                { label: "IAD" },
                { label: "TIAL" },
                { label: "Unmeetneed" },
              ],
            ],

            bodyColumns: ["a", "b", "c", "d"],
            sumColumns: ["a", "b", "c", "d"],
            showTotal: true,
            showSubTotal: true,
            showGrandTotal: false,
            showKet: true,
            showAksi: !isCetak,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title: "PUS Bukan Peserta KB",
                cols: 4,
                fields: [
                  {
                    key: "a",
                    label: "HAMIL",
                    type: "number",
                  },
                  {
                    key: "b",
                    label: "IAS",
                    type: "number",
                  },
                  {
                    key: "c",
                    label: "IAD",
                    type: "number",
                  },
                  {
                    key: "d",
                    label: "TIAL",
                    type: "number",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);

            return {
              ...row,
              a,
              b,
              c,
              d,
              total: a + b + c + d,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 6
      // =========================
      if (id === 6) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Uraian Dokumen", width: "12%" },
                { label: "Target Unmeetneed", width: "12%" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["a"],
            sumColumns: ["a"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  { key: "a", label: "Target Unmeetneed", type: "text" },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);

            return {
              ...row,
              a,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 7
      // =========================
      if (id === 7) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Kabupaten/Kota", width: "12%" },
                { label: "Capaian (%)", width: "12%" },
                { label: "Keterangan", width: "15%" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            bodyColumns: ["a",],
            sumColumns: ["a"],
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
            showTotal: false,
          },

          // ===== FORM (ADD/EDIT) =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Capaian",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);

            return {
              ...row,
              a,
            };
          },
        };
      }

      // =========================
      // DEFAULT
      // =========================
      return {
        id,
        table: {
          headRows: [],
          bodyColumns: [],
          showTotal: false,
          showKet: false,
          showAksi: !isCetak,
        },
        form: {
          groups: [],
          showKet: false,
        },
        calcRow: (row) => row,
      };
    },

    // ini dipakai untuk table view
    normalizedRows() {
      return (this.list_data || []).map(this.indikatorSchema.calcRow);
    },

    // ini dipakai untuk cetak
    normalizedCetakRows() {
      return (this.cetak_data || []).map(this.indikatorSchema.calcRow);
    },
  },

  methods: {
    getCellValue(row, key) {
      return row[key] ?? 0;
    },
    formatDate(val) {
      if (!val) return "-";

      const d = new Date(val);
      if (isNaN(d)) return val;

      return d.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
    getView: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DPPKB + "viewData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log("dasf");

          console.log(res_data);
          console.log("dasf");
          this.list_data = res_data.data;
          this.cetak_data = res_data.cetak;
          this.page_last = res_data.jml_data;
          this.$store.commit("hideLoading");
          this.nama_tahun = res_data.data[0].thn;
          this.indikator = res_data.data[0].indikator;
        });
    },

    getKadis: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Unit + "kadis", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.nama_kadis = res_data[0].nama;
          this.nip_kadis = res_data[0].nip;
          this.pangkat_kadis = res_data[0].pangkat;
          this.gol_kadis = res_data[0].gol;
          this.ruang_kadis = res_data[0].ruang;
          this.gel_dep_kadis = res_data[0].gelar_depan;
          this.gel_bel_kadis = res_data[0].gelar_belakang;
          this.$store.commit("hideLoading");
        });
    },

    getTahun: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Tahun, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_tahun = res_data;
          this.$store.commit("hideLoading");
        });
    },

    getIndikator: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DPPKB + "indikator", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_indikator = res_data;
          this.$store.commit("hideLoading");
        });
    },
    printTable() {
      const printWindow = window.open("", "_blank");
      const content = document.getElementById("printCetak").innerHTML;

      const style = `
    <style>
      @page { margin: 10mm; }

      body {
        font-family: Arial, sans-serif;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        margin: 0;
        padding: 0;
      }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        border: 1px solid #ddd;
        padding: 5px;
        font-size: 11px;
        word-break: break-word;
        white-space: normal;
      }

      .text-center {
        text-align: center !important;
      }

      .print-wrapper {
        transform-origin: top left;
        display: inline-block;
      }
    </style>
  `;

      printWindow.document.open();
      printWindow.document.write(`
    <html>
      <head>
        <title>Dinas Pengendalian Penduduk & Keluarga Berencana</title>
        ${style}
      </head>
      <body>
        <div id="wrapper" class="print-wrapper">
          ${content}
        </div>
      </body>
    </html>
  `);
      printWindow.document.close();

      printWindow.onload = function () {
        const wrapper = printWindow.document.getElementById("wrapper");

        // lebar halaman yang sedang aktif (portrait/landscape ikut user)
        const pageWidth = printWindow.innerWidth;

        // lebar tabel / konten
        const contentWidth = wrapper.scrollWidth;

        if (contentWidth > pageWidth) {
          const scale = pageWidth / contentWidth;
          wrapper.style.transform = `scale(${scale})`;
        } else {
          wrapper.style.transform = "scale(1)";
        }

        printWindow.focus();
        printWindow.print();
      };
    },
    addData: function () {
      // var formData = new FormData();
      // formData.append('data', JSON.stringify(this.form))
      fetch(this.$store.state.url.URL_DPPKB + "addData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menambah Data",
          "light-blue-4",
          "check_circle_outline",
        );
        console.log(res_data);
        this.getView();
      });
    },

    editData: function () {
      console.log(this.form);
      fetch(this.$store.state.url.URL_DPPKB + "editData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify("Sukses Merubah Data", "lime-7", "check_circle_outline");
        this.getView();
      });
    },

    removeData: function (a) {
      fetch(this.$store.state.url.URL_DPPKB + "removeData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({ id: a }),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menghapus Data",
          "deep-orange-10",
          "check_circle_outline",
        );
        this.getView();
      });
    },

    selectData: function (data) {
      this.form.id = data.id;
      this.form.uraian = data.uraian;
      this.form.a = data.a;
      this.form.b = data.b;
      this.form.c = data.c;
      this.form.d = data.d;
      this.form.e = data.e;
      this.form.f = data.f;
      this.form.g = data.g;
      this.form.h = data.h;
      this.form.i = data.i;
      this.form.keterangan = data.keterangan;
      this.form.createAt = data.createAt;
    },

    // ====================================== PAGINATE ====================================
    Notify: function (message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500,
      });
    },
    btn_prev: function () {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },

    // ====================================== PAGINATE ====================================
  },

  mounted() {
    this.getView();
    this.getTahun();
    this.getKadis();
    this.getIndikator();
  },
};
